<div class="drawer-form-wrapper without-bottom-cta" *ngIf="!!logDetail">
  <div class="behaviour-card-sec">
    <div class="header-with-cta mb-24">
      <h3 class="title s-18">{{ logDetail.studentName }}</h3>
    </div>
    <div class="card-content-wrapper secondary">
      <div class="content">
        <h4 class="title">Behavior Category</h4>
        <p class="desc">
          {{ logDetail.behaviorCategoryName }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Data Date</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-clock.svg"
            class="icon s-16"
            aria-label="Clock"></svg-icon>
          {{
            !!logDetail.dataDate
              ? (logDetail.dataDate | userDate: 'MM/dd/yyyy')
              : '-'
          }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Data Type</h4>
        <p class="desc">
          {{ logDetail.dataUnitType }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Time Slot</h4>
        <p class="desc">
          {{ formatTimeSlot(logDetail.timeSlot) }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Old Value</h4>
        <p class="desc">
          {{ logDetail.dataOldValue || '-' }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">New Value</h4>
        <p class="desc">
          {{ logDetail.dataNewValue || '-' }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Last Modified Date</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-clock.svg"
            class="icon s-16"
            aria-label="Clock"></svg-icon>
          {{ logDetail.lastModified | userDate: 'MM/dd/yyyy hh:mm a' }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Modified By</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-user-sm.svg"
            class="icon s-16"
            aria-label="User Sm"></svg-icon>
          {{ logDetail.updatedBy || '-' }}
        </p>
      </div>
    </div>
  </div>
  <div
    class="status added"
    *ngIf="logDetail.dataAuditTypeName === AuditTypeEnums.CREATE">
    <span>Added</span>
  </div>
  <div
    class="status updated"
    *ngIf="logDetail.dataAuditTypeName === AuditTypeEnums.UPDATE">
    <span>Updated</span>
  </div>
  <div
    class="status deleted"
    *ngIf="logDetail.dataAuditTypeName === AuditTypeEnums.DELETE">
    <span>Deleted</span>
  </div>
</div>
